import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { OnboardingType } from "~/schemas/forms/onboarding";
import { FormState } from "~/utils/data";
import { numSteps, steps } from "../../utils/steps";
import { ContentStep } from "../atoms/content-step";
import { Steps, StepsProps } from "./step";

type RenderStepProps = {
  formState: FormState;
  nextStep: () => void;
  form: UseFormReturn<OnboardingType>;
  // tier: Tier;
};

export function RenderStep({ formState, nextStep, form }: RenderStepProps) {
  const { t } = useTranslation();
  const { step, state: _state, teamUrl } = formState;

  // const StepComponent = Component(tier, step);
  const StepComponent = Component(step);
  if (!StepComponent) return <div>Step does not exist</div>;

  const stepProps = {
    form,
    state: _state,
    teamUrl,
    nextStep,
  } satisfies StepsProps;

  // Skip the default styling for some steps
  // if (Styling(tier).includes(step)) return <StepComponent {...stepProps} />;
  if (Styling().includes(step)) return <StepComponent {...stepProps} />;

  // const { icon, heading, numDots } = Content(tier, step);
  const { icon, heading, numDots } = Content(step);

  return (
    <ContentStep icon={icon} heading={t(heading)} numDots={numDots}>
      <StepComponent {...stepProps} />
    </ContentStep>
  );
}

function Styling() {
  const notDefaultStyle = [0, 1];

  // if (tier === "sponsored") {
  //   notDefaultStyle.push(numSponsoredSteps);
  //   return notDefaultStyle;
  // }

  notDefaultStyle.push(numSteps);
  return notDefaultStyle;
}

function Component(step: number) {
  // if (tier === "sponsored") return SponsoredSteps[step];
  return Steps[step];
}

function Content(step: number) {
  // if (tier === "sponsored") return sponsoredSteps[step];
  return steps[step];
}
